import React, { Component } from 'react';
import { Header, Segment, Label, Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';

class ContactPerson extends Component {
  render() {
    const errorLabel = <Label color="red" pointing basic />;

    return (
      <Segment>
        <Header as="h2">Daglig leder/kontaktperson</Header>
        <Form.Group widths="equal">
          <Form.Input
            name="first_name"
            label="Fornavn"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Fornavn er påkrevd',
            }}
            errorLabel={errorLabel}
          />
          <Form.Input
            name="last_name"
            label="Etternavn"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Etternavn er påkrevd',
            }}
            errorLabel={errorLabel}
          />
        </Form.Group>
        <Form.Input
          name="title"
          label="Tittel"
          required
          validationErrors={{
            isDefaultRequiredValue: 'Tittel er påkrevd',
          }}
          errorLabel={errorLabel}
        />
        <Form.Group widths="equal">
          <Form.Input
            name="00Nb0000004encM"
            label="Mobil"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Mobilnummer er påkrevd',
            }}
            errorLabel={errorLabel}
          />
          <Form.Input
            name="email"
            label="E-post"
            required
            validations="isEmail"
            validationErrors={{
              isEmail: 'Dette er ikke en gyldig e-post adresse',
              isDefaultRequiredValue: 'E-post er påkrevd',
            }}
            errorLabel={errorLabel}
          />
        </Form.Group>
        <Message
          header="Notat om epost"
          content="Vi anbefaler å bruke en e-postadresse tilknyttet bedriften din, heller enn en personlig e-postadresse."
        />
      </Segment>
    );
  }
}

export default ContactPerson;



// WEBPACK FOOTER //
// ./src/Form/ContactPerson.js